import { getAction } from '@/api/manage'
import Vue from 'vue'

// 字典标签专用（通过code获取字典数组）
export const ajaxGetDictItems = (code, params) => getAction(`/sys/dict/getDictItems/${code}`, params)

// JDictSelectTag组件不从数据字典拿数据时调用的接口
export const ajaxGetDictItemsForUrl = url => getAction(url)

// 从缓存中获取字典配置
function getDictItemsFromCache(dictCode) {
  let cachDictData = Vue.ls.get('cache_dict_data:' + dictCode)
  if (cachDictData) {
    let dictItems = cachDictData
    return dictItems
  }
}

export { getDictItemsFromCache }



// WEBPACK FOOTER //
// ./src/api/api.js